import React, {Component} from 'react';
import {connect} from 'react-redux';

import {__} from '~/shared/src/utilities/messageCatalog';
import User from '~/shared/src/model/User';

import {
    InputSwitch,
    InputSwitchChangeEvent
} from 'primereact/inputswitch';
import {Panel} from 'primereact/panel';

import ContentButton from '~/frontend/src/components/base/shared/ContentButton';

import {StoreState} from '~/frontend/src/store';


export type Option = {
    name : string;
    label : string;
    value : boolean;
    disabled? : boolean;
}

type DefaultProps = {
    disabled? : boolean;
};
const defaultProps : Required<DefaultProps> = {
    disabled: false
};

type Props = {

    /**
     * The uniqueId of the panel the component is used in.
     *
     * Mostly used to extract the components state from the global one
     * and to generate unique dom element ids.
     */
    uid : string;

    id : string;

    /**
     * The options to show.
     */
    options : Option[];

    /**
     * The handler for view option change.
     *
     * @param {String} name
     * @param {Boolean} checked
     */
    onViewOptionChange : ( name : string, checked : boolean ) => void;

    /**
     * The CSS class name(s) to add to the component.
     */
    className? : string;

    tabIndex? : number;
};

type StateProps = {

    /**
     * The current user.
     *
     * Will be mapped from global state.
     */
    user? : User;
};

export type ComponentProps = DefaultProps & Props;
type AllProps = Required<DefaultProps> & Props & StateProps;


/**
 * ViewOptionsMenu
 */
class ViewOptionsMenu extends Component<AllProps> {

    static defaultProps = defaultProps;

    /**
     * @param props
     */
    constructor( props : AllProps ) {
        super( props );

        // bind event handlers
        this.onViewOptionChange = this.onViewOptionChange.bind( this );
    }

    /**
     * Handler for view option InputSwitch change.
     *
     * @param event
     *
     * @private
     */
    onViewOptionChange( event : InputSwitchChangeEvent ) {
        const checked = event.value;

        let inputId,
            name;

        const target = event.originalEvent?.target as HTMLElement;

        if ( target?.parentNode?.childNodes[ 0 ].childNodes[ 0 ] ) {
            inputId = ( target.parentNode.childNodes[ 0 ].childNodes[ 0 ] as HTMLElement ).id;
        }

        if ( inputId ) {
            name = inputId.replace( `${this.props.uid}_`, '' );

            if ( name ) {
                this.props.onViewOptionChange( name, checked );
            }
        }
    }

    /**
     * Builds the show flag input switch
     *
     * @return {JSX.Element[]}
     *
     * @private
     */
    renderViewOptions() {
        const retVal = [],
              {
                  uid,
                  options
              }      = this.props;

        for ( const option of options ) {
            const id       = `${uid}_${option.name}`,
                  disabled = option.disabled ?? false;

            retVal.push(
                <div
                    key={option.name}
                    className="yn-header-inputswitch"
                >
                    <InputSwitch
                        inputId={id}
                        checked={option.value}
                        disabled={disabled}
                        onChange={this.onViewOptionChange}
                    />
                    <label
                        htmlFor={id}
                    >
                        {option.label}
                    </label>
                </div>
            );
        }

        return retVal;
    }

    /**
     * REACT lifecycle method
     */
    render() {
        const {
                  uid,
                  id,
                  className,
                  disabled,
                  tabIndex
              } = this.props;

        return <ContentButton
            id={id}

            horizontalContentAlign="right"
            verticalContentAlign="bottom"
            rounded={true}
            text={true}
            icon="pi pi-eye"
            className={`yn-toolbar-button yn-option-button yn-view-option-button ${className}`}
            contentClassName="yn-contentbutton-overlay-content-page-menu"
            tooltip={__( 'YN.base.viewOptions.button' )}
            tooltipOptions={config.frontend?.buttonTooltipOptions}
            tabIndex={tabIndex}

            disabled={disabled}

            content={
                <Panel
                    className="yn-finder-view-options"
                    style={{ width: '25rem' }}
                >
                    <label
                        key={`${uid}_header`}

                        className="yn-menu-title-label"
                    >
                        {__( 'YN.base.viewOptions.label' )}
                    </label>
                    {this.renderViewOptions()}
                </Panel>
            }
        />;
    }

}

/**
 * REDUX stuff
 */
function mapStateToProps( state : StoreState, ownProps : ComponentProps ) : StateProps {
    const retVal : StateProps = {
        user: undefined
    };

    // get some session user information
    if ( state.session?.user ) {
        retVal.user = state.session.user;
    }

    return retVal;
}

export default connect( mapStateToProps, null )( ViewOptionsMenu );
